export const INVENTORY_MOVEMENTS_COLLECTION = 'inventoryMovements';
export const INVENTORY_LOCATIONS_COLLECTION = 'inventoryLocations';

/** ID lógico para ítems en tránsito / sin ubicación fija. */
export const TRANSIT_LOCATION_SENTINEL = '__transit__';
